import script from "./CreatedRule.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatedRule.vue?vue&type=script&setup=true&lang=js"

import "./CreatedRule.vue?vue&type=style&index=0&id=5dc8d788&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dc8d788"]])

export default __exports__